'use client'

import React from 'react'
import classes from './index.module.css'

export const AnimatedHeading: React.FC<{
  text: string
  color?: string
  waveColors?: string[]
  glowColors?: string[]
}> = ({
  text,
  color = '#ffffff',
  waveColors = ['#10b981', '#34d399', '#6ee7b7', '#10b981'],
  glowColors = [
    'rgba(16, 185, 129, 0.3)',
    'rgba(52, 211, 153, 0.4)',
    'rgba(110, 231, 183, 0.5)',
    'rgba(16, 185, 129, 0.4)',
  ],
}) => {
  return (
    <h1 className={classes.animatedHeading}>
      {text.split('').map((char, index) => (
        <span
          key={index}
          className={classes.character}
          style={
            {
              animationDelay: `${index * 0.1}s`,
              '--base-color': color,
              '--wave-1': waveColors[0],
              '--wave-2': waveColors[1],
              '--wave-3': waveColors[2],
              '--wave-4': waveColors[3] || waveColors[0],
              '--glow-1': glowColors[0],
              '--glow-2': glowColors[1],
              '--glow-3': glowColors[2],
              '--glow-4': glowColors[3] || glowColors[0],
            } as React.CSSProperties
          }
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </h1>
  )
}
